import { Box } from '@mui/material'
import React from 'react'

type BannerColor = 'error' | 'info' | 'success' | 'warning'

const backgroundColors: Record<BannerColor, string> = {
  error: '#d32f2f',
  info: '#0288d1',
  success: '#2e7d32',
  warning: '#ed6c02',
}

export const BANNER_HEIGHT = 41

interface AppBannerProps {
  readonly visible: boolean
  readonly severity?: BannerColor
  readonly top?: number
  readonly children: React.ReactNode
}

const AppBanner: React.FC<AppBannerProps> = ({
  visible,
  severity = 'warning',
  top = 0,
  children,
}) => {
  if (!visible) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: `${top}px`,
        left: 0,
        width: '100%',
        height: `${BANNER_HEIGHT}px`,
        backgroundColor: backgroundColors[severity],
        color: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.95rem',
        fontWeight: 500,
        fontFamily: 'Heebo, sans-serif',
        zIndex: 1200,
      }}
    >
      {children}
    </Box>
  )
}

export default AppBanner
